import styled from 'styled-components'
import { Button } from 'react-bootstrap'
import {
  PageHeader,
  PageTitle,
  MeetingRoomToolbarActions,
} from '../pageLayoutStyles'

export { PageHeader, PageTitle, MeetingRoomToolbarActions }
export { MeetingRoomToolbarActions as MeetingRoomOrderAndButtonRow }

export const GearButton = styled(Button)`
  &&& {
    background: #fff !important;
    border: 2px solid #0072bc !important;
    color: #0072bc !important;
    box-shadow: none !important;
  }

  border-radius: 6px;
  width: 48px;
  height: 48px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;

  &&&:hover,
  &&&:focus,
  &&&:focus-visible,
  &&&:active,
  &&&:first-child:active {
    background: #fff !important;
    border-color: #0072bc !important;
    color: #0072bc !important;
    box-shadow: none !important;
  }
`

export const ManageMeetingRoomEmptyRoot = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: min(420px, calc(100vh - 280px));
  padding: 48px 24px;
  text-align: center;
`

export const ManageMeetingRoomEmptyIconWrap = styled.div`
  color: #aeb4bd;
  line-height: 1;
  margin-bottom: 20px;
`

export const ManageMeetingRoomEmptyText = styled.p`
  font-weight: 600;
  font-size: 1rem;
  color: var(--bs-grey-dark);
  margin: 0;
  max-width: 420px;
  line-height: 1.5;
`
